import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { ApiService } from 'src/core/http/api.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class UserService {
  private endPointBaseurl: string;

  constructor(
    private apiService: ApiService) {
      this.endPointBaseurl = environment.appApiUrl;
    }


  public getUsers(startIndex = 0, pageSize = 40, sorting = '', search = '', status = 'All'): Observable<any> {
    const searchParams = new HttpParams()
    .set('start', startIndex.toString())
    .set('pageSize', pageSize.toString())
    .set('sorting', sorting)
    .set('search', search)
    .set('status', status);

    return this.apiService.Get('users/list', searchParams);
  }


  public getUser(authUserId: number | string): Observable<any> {
    return this.apiService.Get('users/' + authUserId);
  }


  public checkUserEmail(emailAddress: string) {
    const searchParams = new HttpParams()
    .set('emailAddress', emailAddress);
    return this.apiService.Get('users/email/validate', searchParams);
  }


  public confirm(token: string): Observable<any> {
    const searchParams = new HttpParams()
    .set('token', token);
    return this.apiService.Get('users/confirm', searchParams, false);
  }


  public saveUser(user: any): Observable<any> {
    return this.apiService.Post('users', user);
  }


  public emailRegistration(authUserId: any): Observable<any> {
    const searchParams = new HttpParams()
    .set('authUserId', authUserId.toString());
    return this.apiService.Get('users/email/registration', searchParams);
  }

}
